"use client";

import urls from "@/utils/urls/urls";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
export default function FaviconDynamic() {
  const [favicon_image, setFavicon_image] = useState<string>("");

  useEffect(() => {
    const favicon_image = async () => {
      try {
        const res = await axios.get(urls?.setting);
        // console.log("favicon_image =", res?.data?.data[0]?.fav_image);
        setFavicon_image(res?.data?.data[0]?.fav_image);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    favicon_image();
  }, []);

  // console.log(`favicon_image full url = ${urls?.root}${favicon_image}`);

  return (
    <HelmetProvider>
      <Helmet>
        <link
          rel="icon"
          type="image/x-icon"
          href={`${urls?.root}${favicon_image}`}
        />
      </Helmet>
      {/* <img src={`${urls?.root}${favicon_image}`} alt="favicon" /> */}
    </HelmetProvider>
  );
}
